var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "split-container has-text-centered" }, [
    _c(
      "div",
      { staticClass: "qrcode-container" },
      [
        _c(
          "div",
          { staticClass: "has-text-centered color-black" },
          [_c("check-icon", { attrs: { size: "5x" } })],
          1
        ),
        _vm.userState.subscription_active
          ? _c("p", { staticClass: "subtitle has-text-centered" }, [
              _c("strong", { staticStyle: { "font-size": "120%" } }, [
                _vm._v(
                  _vm._s(_vm.$t("profile.active_subscription").toUpperCase())
                ),
              ]),
            ])
          : _vm.userState.trial_active
          ? _c("p", { staticClass: "subtitle has-text-centered" }, [
              _c(
                "strong",
                {
                  staticClass: "padding-mobile-trial",
                  staticStyle: { "font-size": "120%" },
                },
                [_vm._v(_vm._s(_vm.$t("profile.active_trial").toUpperCase()))]
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "subtitle margin-top-md" }, [
          _c(
            "div",
            {
              staticClass:
                "columns is-mobile is-centered is-vcentered is-multiline columns-no-padding-vertical",
            },
            [
              _c(
                "div",
                { staticClass: "column is-narrow column-wide-mobile" },
                [_vm._v(_vm._s(_vm.$t("profile.app_step1a")))]
              ),
              _vm._m(0),
              _c("div", { staticClass: "column is-narrow no-padding-left" }, [
                _c("strong", [_vm._v(_vm._s(_vm.$t("profile.app_step1b")))]),
              ]),
              _c("div", { staticClass: "column is-narrow no-padding-left" }, [
                _vm._v(_vm._s(_vm.$t("profile.app_step1c"))),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "columns is-mobile is-centered is-vcentered is-multiline columns-no-padding-vertical",
            },
            [
              _c(
                "div",
                {
                  staticClass: "column no-padding-left",
                  staticStyle: { "line-height": "1.6" },
                },
                [_vm._v(_vm._s(_vm.$t("profile.app_step1d")))]
              ),
            ]
          ),
        ]),
        _c(
          "div",
          { staticClass: "app-container" },
          [_c("android-app"), _c("ios-app")],
          1
        ),
        _vm.userQrcode
          ? _c(
              "p",
              { staticClass: "subtitle margin-top-md has-text-centered" },
              [_vm._v(_vm._s(_vm.$t("profile.app_step2")))]
            )
          : _vm._e(),
        _vm.userQrcode
          ? _c(
              "div",
              { staticClass: "has-text-centered" },
              [
                _c("qrcode", {
                  attrs: { value: _vm.userQrcode, options: _vm.qrCodeOptions },
                }),
                _vm.counting
                  ? _c("countdown", {
                      attrs: { time: 60000 },
                      on: { end: _vm.handleCountdownEnd },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("profile.app_step_seconds", {
                                      seconds: props.totalSeconds,
                                    })
                                  )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3258250447
                      ),
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm.userState.trial_active
          ? [
              _c(
                "p",
                {
                  staticClass:
                    "subtitle margin-top-md no-line-break-mobile has-text-centered",
                  staticStyle: { "margin-bottom": "0rem" },
                },
                [
                  _c("strong", { staticStyle: { "font-weight": "700" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("profile.app_step3").toUpperCase() + " ")
                    ),
                  ]),
                ]
              ),
              _c(
                "p",
                {
                  staticClass: "subtitle subtitle-payment",
                  staticStyle: { "margin-bottom": "0.5rem" },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("profile.payment_info_to_continue1b") + " ")
                  ),
                  _c("span", { staticStyle: { "font-weight": "700" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("profile.payment_info_to_continue2") + " ")
                    ),
                  ]),
                  _vm._v(_vm._s(_vm.$t("profile.payment_info_to_continue3"))),
                ]
              ),
              _c(
                "p",
                {
                  staticClass: "subtitle subtitle-payment",
                  staticStyle: { "margin-bottom": "0.5rem" },
                },
                [
                  _c("span", { staticStyle: { "font-weight": "700" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("profile.payment_info_to_continue4") + " ")
                    ),
                  ]),
                  _c("br"),
                  _vm._v(_vm._s(_vm.$t("profile.payment_info_to_continue5"))),
                  _c("ol", { staticStyle: { "padding-left": "1.1rem" } }, [
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("profile.payment_info_guide_1"))),
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("profile.payment_info_guide_2"))),
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("profile.payment_info_guide_3"))),
                    ]),
                  ]),
                ]
              ),
              _c("p", { staticClass: "subtitle subtitle-payment" }, [
                _vm._v(_vm._s(_vm.$t("profile.payment_info_guide_4"))),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow no-padding-left" }, [
      _c("img", {
        staticStyle: { width: "2.2rem", display: "block" },
        attrs: { src: "/icon.png", alt: "", draggable: "false" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }